import React from 'react';
import propTypes from 'prop-types';
import swal from 'sweetalert2';
import moment from 'moment';
import shortid from 'shortid';
import { spmfcloudFunctionUrl } from '../../../actions/salesforces';

class TrackedField extends React.Component {
    constructor() {
        super();
        this.state = {
            fieldHistory: [],
            loading: false,
        };
    }

    async componentWillMount() {
        const { objectName, salesforceId, hashToken } = this.props;
        this.setState({ loading: true });
        try {
            const fieldHistory = await fetch(`${spmfcloudFunctionUrl}/tracking/read/${objectName}/${salesforceId}?limit=20`, {
                headers: {
                    'Content-Type': 'application/json',
                    'hash-token': hashToken,
                },
            }).then((res) => {
                if (res.status !== 200) throw new Error('Failed to get field history');
                return res.json();
            });
            this.setState({ fieldHistory, loading: false });
        } catch (error) {
            swal('Error', error.message, 'warning');
            this.setState({ loading: false });
        }
    }

    async componentWillReceiveProps(nextProps) {
        if (nextProps.salesforceId === this.props.salesforceId) return false;
        return this.componentWillMount();
    }

    render() {
        const { fieldHistory, loading } = this.state;
        if (loading) {
            return (
                <i className="fa fa-1x fa-spinner fa-spin text-center" />
            );
        }
        if (fieldHistory.length === 0) {
            return (
                <div className="tracked-field">
                    {this.props.withTitle ? [
                        <h4 key={shortid.generate()}>History</h4>,
                        <hr key={shortid.generate()} />,
                    ] : null}
                    <p style={{ fontSize: 16 }}>There is no history</p>
                </div>
            );
        }
        const notPrintedKey = ['attributes', 'Id'];
        return (
            <div className="tracked-field">
                {this.props.withTitle ? [
                    <h4>History</h4>,
                    <hr />,
                ] : null }
                <table className="table">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>User</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {fieldHistory.map(history => (
                            <tr>
                                <td>{moment(history.timestamp).format('DD-MMM-YY HH:mm')}</td>
                                <td>
                                    {history.changedBy.name}
                                    {`(${history.changedBy.authority})`}
                                </td>
                                <td>
                                    {Object.keys(history.changes).map((key) => {
                                        if (notPrintedKey.indexOf(key) > -1) return null;
                                        if (history.changes[key].old === null && history.changes[key].new === null) return null;
                                        return (
                                            <p>
                                                <span style={{ fontWeight: 600 }}>
                                                    {history.changes[key].label}
                                                </span>
                                                &nbsp;changes
                                                {
                                                    history.changes[key].old ? (
                                                        <span>
                                                            &nbsp;from&nbsp;
                                                            <span style={{ fontWeight: 600 }}>
                                                                {history.changes[key].old}
                                                            </span>
                                                        </span>
                                                    ) : null
                                                }
                                                &nbsp;to&nbsp;
                                                <span style={{ fontWeight: 600 }}>
                                                    {history.changes[key].new}
                                                </span>
                                            </p>
                                        );
                                    })}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }
}

TrackedField.propTypes = {
    objectName: propTypes.string.isRequired,
    salesforceId: propTypes.string.isRequired,
    hashToken: propTypes.string.isRequired,
    withTitle: propTypes.bool,
};

TrackedField.defaultProps = {
    withTitle: true,
};

export default TrackedField;



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/common/TrackedField.js
// module id = 212
// module chunks = 0